/* Author the direction in HTML. Visible defaults are the no-JS/API fallback. */
(() => {
  const root = document.querySelector('.ikal-essay');
  if (!root || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 700px)');
  const control = root.querySelector('.essay-motion-toggle');
  const running = new Set();
  const seen = new WeakSet();
  const targets = [...root.querySelectorAll('[data-reveal]')];
  let enabled = true;
  const stop = () => { for (const animation of running) animation.cancel(); running.clear(); };
  const label = () => {
    if (!control) return;
    control.hidden = false;
    control.disabled = reduce.matches;
    control.setAttribute('aria-pressed', String(enabled && !reduce.matches));
    control.textContent = reduce.matches ? 'Image motion: reduced' : `Image motion: ${enabled ? 'on' : 'off'}`;
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const el = entry.target;
      observer.unobserve(el);
      if (seen.has(el)) continue;
      seen.add(el);
      const rect = el.getBoundingClientRect();
      if (reduce.matches || !enabled || document.hidden || rect.bottom <= 0 || rect.top >= innerHeight || el.contains(document.activeElement)) continue;
      // Do not animate an empty lazy-image box; its reserved space remains visible.
      const img = el.querySelector('img');
      if (img && (!img.complete || !img.naturalWidth)) continue;
      const kind = el.dataset.reveal;
      const x = mobile.matches ? 14 : 36;
      const y = mobile.matches ? 18 : 28;
      const offset = kind === 'left' ? [-x, 8] : kind === 'right' ? [x, 8] : kind === 'quiet' ? [0, 10] : [0, y];
      const animation = el.animate([
        {opacity: kind === 'quiet' ? .65 : .35, transform: `translate(${offset[0]}px, ${offset[1]}px)`},
        {opacity: 1, transform: 'translate(0px, 0px)'}
      ], {duration: kind === 'quiet' ? 500 : kind === 'up' ? 800 : 720, easing: 'cubic-bezier(.22,1,.36,1)'});
      running.add(animation);
      animation.finished.catch(() => {}).finally(() => running.delete(animation));
    }
  }, {threshold: 0, rootMargin: '0px 0px -32px 0px'});
  const settleVisible = () => {
    stop();
    targets.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > 0) { seen.add(el); observer.unobserve(el); }
    });
  };
  targets.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < innerHeight) seen.add(el);
    else observer.observe(el);
  });
  control?.addEventListener('click', () => { enabled = !enabled; if (!enabled) stop(); label(); });
  reduce.addEventListener('change', () => { if (reduce.matches) stop(); label(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  root.addEventListener('focusin', stop);
  window.addEventListener('beforeprint', stop);
  window.addEventListener('hashchange', settleVisible);
  window.addEventListener('pageshow', settleVisible);
  // Initial hash navigation and scroll restoration settle after layout.
  requestAnimationFrame(settleVisible);
  label();
})();
